import { render, staticRenderFns } from "./AddColumnsStep.vue?vue&type=template&id=6a787ccc&scoped=true"
import script from "./AddColumnsStep.vue?vue&type=script&lang=js"
export * from "./AddColumnsStep.vue?vue&type=script&lang=js"
import style0 from "./AddColumnsStep.vue?vue&type=style&index=0&id=6a787ccc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a787ccc",
  null
  
)

export default component.exports